import { useLocation } from "react-router-dom";

import { Link, Text } from "@alpacahq/ui/old";

import { Footer } from "../../components/common/footer";
import App from "../";
import { AlpacaLogo } from "./AlpacaLogo";
import { Create } from "./CreateAccount";
import { FeatureItem } from "./FeatureItem";
import { Pending } from "./PendingVerification";
import { Verified } from "./Verified";

export interface SignUpLocationState {
  email: string;
  last_name: string;
  first_name: string;
  user_sub: string;
}

export const DOCS_URL = "https://docs.alpaca.markets/docs/getting-started";
export const CONTACT_URL = "https://alpaca.markets/contact";

const steps: { [key: string]: JSX.Element } = {
  "/verify": <Pending />,
  "/signup": <Create />,
  "/signup/pending": <Pending />,
  "/signup/success": <Verified />,
};

const SignUpPage = () => {
  const { pathname } = useLocation();
  const stepComponent = steps[pathname] ?? steps["/signup"];

  return (
    <App>
      <div className="mx-auto">
        <div className="flex h-auto flex-col lg:h-fit lg:flex-row">
          <div className="mx-auto flex w-full items-center py-16">
            <div className="fade-in-up-faster flex w-full justify-center min-[1890px]:justify-end min-[1890px]:pr-48">
              <div className="flex w-full max-w-[500px] flex-col items-center gap-7">
                <AlpacaLogo />
                {stepComponent}
              </div>
            </div>
          </div>
          <div className="flex min-h-auto w-full justify-center bg-yellow-300 px-8 py-8 text-center lg:min-h-[732px] min-[1890px]:justify-start min-[1890px]:pl-48">
            <div className="items-between fade-in-up-fast flex flex-col justify-center gap-8 pt-3">
              <FeatureItem
                title="Easy to Use, Developer-First API"
                description="Build, backtest and deploy your strategy across thousands of stocks, ETFs, options, and crypto with Trading API."
              />
              <FeatureItem
                title="Commission-Free Trading for Retail Investors"
                description="Trade stocks, ETFs, and options with zero commissions using our powerful API and  Web Dashboard."
              />
              <FeatureItem
                title="Advanced Algorithmic Trading for Institutional Investors"
                description="Elevate your trading experience with our cost-effective solutions. Benefit from ultra-low 1.5ms latency, dedicated white-glove support, and a full suite of advanced order types."
              />
              <FeatureItem
                title="Real-time Market Data"
                description="Real-time and historical market data for both paper and live trading. Trade smarter with a complete view of the market."
              />
              <Text className="pt-8 text-center">
                Want to build a trading app on top of our APIs? Head over to{" "}
                <Link
                  className="underline"
                  href="https://broker-app.alpaca.markets/sign-up"
                >
                  Broker API
                </Link>
              </Text>
            </div>
          </div>
        </div>
      </div>
      <div className="p-4">
        <Footer />
      </div>
    </App>
  );
};

export default SignUpPage;
